//import React from 'react';

import React, {useEffect, useState} from 'react';  
import { Modal,Button } from 'react-bootstrap';
import Sidebar from '../Sidebar/Sidebar';
import { fetchOrders } from '../../../redux/slices/Customer/OrdersSlice';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';

const  Orders = () => {
  const {orders} = useSelector((state:any) => state.customerOrders)
  const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
  const [modalShow, setModalShow] = useState(false);
  const [tabShow, setTabShow] = useState('History');
  const [selectedOrder, setSelectedOrder] = useState('' as any);
  const handleModalClose = () => setModalShow(false);
  const [shippingCharges, setShippingCharges] = useState(80);
  const [subTotal, setSubTotal] = useState(0);
  
  const getDate = (cDate) => {
    const today = new Date(cDate);
    const month = today.toLocaleString('default', { month: 'short' });//today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${month} ${date}, ${year}`;
  }

  const handleModalOpen = (order) => {
    setModalShow(true);
    setSelectedOrder(order);
    calShippingCharges(order);
    order['line_items'].map((item) => item + item.price)
    setSubTotal(order['line_items'].reduce((sum, item) => sum + parseFloat(item.price), 0));

  }
  const getStatusColor = (status) => {
    switch(status){
    case "Pending" :
      return "bg-dark"
    case "Order Placed":
      return "badge-OrderPlaced"
    case "Packaged":
      return "badge-Packaged"
    case "Shipped":
      return "badge-Shipped"
    case "Cancelled":
      return "badge-Cancelled"
    case "Delivered":
      return "badge-Delivered"
      
    }
  }
 
    const calShippingCharges = (order) => {
       const k = order['line_items'].length;
       const shippingCharge = 5 *( k * k) + (25 * k) + 50;
       setShippingCharges(shippingCharge);
    }

  useEffect(() =>{
    dispatch(fetchOrders());
  },[dispatch])

  return (
    <div className="page-content bg-light">
      <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
        <div className="container">
          <div className="dz-bnr-inr-entry">
            <h1>My Account</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row">
              <ul className="breadcrumb">
              <li className="breadcrumb-item"><span> Home</span></li>
                <li className="breadcrumb-item"> Orders</li>
              </ul>
            </nav>
          </div>
        </div>	
      </div> 
      
      <div className="content-inner-1">
        <div className="container">
          <div className="row">
            <Sidebar selectedLink={"My Orders"}/>
            <section className="col-xl-9 account-wrapper">
              <div className="account-card">
                
                {orders && orders.length === 0 && "You haven't placed any orders yet. Go ahead and create your first order."}
                {orders && orders.length > 0 && 
                  <>
                    <div className="table-responsive table-style-1">
                      <table className="table table-hover mb-3">
                        <thead>
                          <tr>
                            <th>Order #</th>
                            <th>Date Purchased</th>
                            <th>Total</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders && orders.map((order) => 
                            <tr>
                              <td>#{order.order_number}</td>
                              <td>{getDate(order.created_at)}</td>
                              <td>₹{order.payment ? order.payment.amount : "-"}</td>
                              <td><span className={"badge  m-0 " +getStatusColor(order.status) }>{order.status}</span></td>
                              <td><button className="btn-link text-underline p-0 removeBtnBG" onClick={() => handleModalOpen(order)}>View</button></td>
                            </tr>
                          )}
                          
                        
                        </tbody>
                      </table>
                    </div>
                    
                    {/* <div className="d-flex justify-content-center">
                      <nav aria-label="Table Pagination">
                        <ul className="pagination style-1">
                          <li className="page-item"><a className="page-link" href="javascript:void(0);">Prew</a></li>
                          <li className="page-item"><a className="page-link" href="javascript:void(0);">1</a></li>
                          <li className="page-item"><a className="page-link" href="javascript:void(0);">2</a></li>
                          <li className="page-item"><a className="page-link" href="javascript:void(0);">3</a></li>
                          <li className="page-item"><a className="page-link" href="javascript:void(0);">Next</a></li>
                        </ul>
                      </nav>
                    </div> */}
                  </>
                } 
                
              </div>
            </section>
          </div>
        </div>
      </div>
      <Modal size="xl" show={modalShow} onHide={handleModalClose}>
                
                <Modal.Header closeButton>
                    <Modal.Title>Order Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="mb-3 p-a20">
                      <div className="col-xl-12"> 
                        <section className="col-xl-9 account-wrapper">
                          <div className="account-card order-details">
                            <div className="order-head">
                              <div className={"head-thumb tshirtImage bG" + (selectedOrder.line_items && selectedOrder.line_items[0] && selectedOrder.line_items[0].color && selectedOrder.line_items[0].color.replace("#", "")) }>
                                <img src={ selectedOrder.line_items && selectedOrder.line_items[0] && selectedOrder.line_items[0].variant.variant_images && process.env.REACT_APP_SERVER_URL + selectedOrder.line_items[0].variant.variant_images[0].variant_image.thumb.url} alt="variant"/>
                              </div>
                              <div className="clearfix m-l20">
                                <div className={"badge " + getStatusColor(selectedOrder.status) }>{selectedOrder.status}</div>
                                <h4 className="mb-0">Order #{selectedOrder.order_number}</h4>
                              </div>
                            </div>
                            <div className="row mb-sm-4 mb-2">
                              <div className="col-sm-6">
                                <div className="shiping-tracker-detail">
                                  <span>Items Count</span>
                                  <h6 className="title">{selectedOrder && selectedOrder.line_items.length}</h6>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="shiping-tracker-detail">
                                  <span>Courier</span>
                                  <h6 className="title">-</h6>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="shiping-tracker-detail">
                                  <span>Date Purchased</span>
                                  <h6 className="title">{getDate(selectedOrder.created_at)}</h6>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="shiping-tracker-detail">
                                  <span>Address</span>
                                  <h6 className="title">{selectedOrder && selectedOrder.shipping_address && selectedOrder.shipping_address.replace(/<br\/>/g, '')}</h6>
                                </div>
                              </div>
                            </div> 
                            <div className="clearfix">
                              <div className="dz-tabs style-3">
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                  <button className={"nav-link " + (tabShow === 'History' ? ' show active' : '')} id="nav-order-history-tab" onClick={ () => setTabShow('History')}>Order History</button>
                                  <button className={"nav-link " + (tabShow === 'Details' ? ' show active' : '')} id="nav-Item-tab"  onClick={ () => setTabShow('Details')}>Item Details</button> 
                                </div>
                              </div>
                              <div className="tab-content" id="nav-tabContent">
                                <div className={"tab-pane fade " + (tabShow === 'History' ? ' show active' : '')} id="nav-order-history" role="tabpanel" aria-labelledby="nav-order-history-tab" >
                                  <div className="widget-timeline style-1">
                                    <ul className="timeline">
                                    <li>
                                        <div className="timeline-badge"></div>
                                        <div className="timeline-box">
                                          <div className="timeline-panel" >
                                            <h6 className="mb-0">Order Palced</h6>
                                            <span>{getDate(selectedOrder.created_at)}</span>
                                          </div>
                                        </div>
                                      </li>
                                      {['Packaged','Shipped','Delivered'].includes(selectedOrder.status) ? 
                                      ( 
                                      <li>
                                        <div className="timeline-badge "></div>
                                        <div className="timeline-box">
                                          <div className="timeline-panel" >
                                            <h6 className="mb-0">Product Packaged</h6>
                                          </div> 
                                        </div>
                                      </li>
                                      ) : ''
                                    }
                                    {['Shipped','Delivered'].includes(selectedOrder.status) ? 
                                      (
                                        <li>
                                        <div className="timeline-badge "></div>
                                        <div className="timeline-box">
                                          <div className="timeline-panel" >
                                            <h6 className="mb-0">Product Shipped</h6>
                                          </div> 
                                        </div>
                                      </li>
                                      ) : ''
                                    }
                                     
                                     {['Cancelled'].includes(selectedOrder.status) ? 
                                      (
                                        <li>
                                        <div className="timeline-badge primary"></div>
                                        <div className="timeline-box">
                                          <div className="timeline-panel" >
                                            <h6 className="mb-0">Cancelled</h6>
                                          </div>
                                        </div>
                                      </li>
                                      ) : ''
                                    }
                                    {['Delivered'].includes(selectedOrder.status) ? 
                                      (
                                        <li>
                                        <div className="timeline-badge success"></div>
                                        <div className="timeline-box">
                                          <div className="timeline-panel" >
                                            <h6 className="mb-0">Delivered</h6>
                                          </div>
                                        </div>
                                      </li>
                                      ) : ''
                                    }
                                                                         
                              
                                    </ul>
                                  </div>
                                </div>
                                <div className={"tab-pane fade " + (tabShow === 'Details' ? ' show active' : '')} id="nav-Item" role="tabpanel" aria-labelledby="nav-Item-tab" >
                                  <h5>Item Details</h5>
                                  {selectedOrder && selectedOrder['line_items'].map((item) => 
                                    <div className="tracking-item">
                                      <div className="tracking-product"><img src={item.variant.variant_images && process.env.REACT_APP_SERVER_URL + item.variant.variant_images[0].variant_image.thumb.url} alt="product"/></div>
                                      <div className="tracking-product-content">
                                        <h6 className="title">{item.variant.product.name}</h6>
                                        <small className="d-block"><strong>Price</strong> : ₹ {item.price}</small>
                                        {item.size && <small className="d-block"><strong>Size</strong> :  {item.size}</small>}
                                        <small className="d-block"><strong>Status</strong> : <div className={"badge " + getStatusColor(item.order_status) }>{item.order_status}</div></small>
                                      </div>
                                    </div>
                                  )}
                                  <div className="tracking-item-content">
                                    <span>Sub Total </span>
                                    <h6> ₹ {subTotal}</h6>
                                  </div>
                                    <div className="tracking-item-content border-bottom border-light mb-2">
                                    <span className="text-success">Shipping</span>
                                    <h6>₹ {shippingCharges}</h6>
                                  </div>
                                    <div className="tracking-item-content">
                                    <span>Order Total</span>
                                    <h6>₹ {shippingCharges + subTotal}</h6>
                                  </div>
                                </div> 
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                  </div> 
                </Modal.Body>
                <Modal.Footer>
                 
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                </Modal.Footer> 
       
                  
              </Modal>
	  </div>
  );
}

export default Orders;

 
